import { RecordFactory } from '.'
import type { RecordStrategy, RecordStrategyArgs } from '../types'

export class SpaceRecord implements RecordStrategy {
  async set(args: RecordStrategyArgs = {}): Promise<void> {
    const { spaceId } = args
    if (!spaceId) {
      this.remove()
      return
    }

    window?.CommandBar?.addMetadata('spaceId', spaceId)
    this.setRecords(args)
  }

  async remove(): Promise<void> {
    window?.CommandBar?.addMetadata('spaceId', undefined)
    window?.CommandBar?.addMetadata('spaceName', undefined)
    window?.CommandBar?.addMetadata('isDemoSpace', undefined)
    await RecordFactory.getRecord('stories').remove!()
    await RecordFactory.getRecord('apps').remove!()
    await RecordFactory.getRecord('components').remove!()
    await RecordFactory.getRecord('assets').remove!()
    await RecordFactory.getRecord('datasources').remove!()
    await RecordFactory.getRecord('quick_filters').remove!()
  }

  async setRecords(args: RecordStrategyArgs = {}): Promise<void> {
    await RecordFactory.getRecord('apps').set!(args)
    await RecordFactory.getRecord('components').set!(args)
    await RecordFactory.getRecord('assets').set!(args)
    await RecordFactory.getRecord('datasources').set!(args)
    await RecordFactory.getRecord('stories').set!(args)
    await RecordFactory.getRecord('quick_filters').set!(args)
  }
}
